import { type MantineColor, Text } from "@mantine/core";
import { useEffect, useMemo } from "react";
import { useTimer } from "react-timer-hook";
import { formatTime } from "@/shared-utils";
import { ChatPreviewBadge } from "./ChatPreviewBadge";
import { ElapsedTimeValue } from "./ElapsedTimeValue";

export const AboutToEnd = ({
    endReason,
    endAt,
    endReasonColor,
}: {
    endReason: string;
    /** Unix timestamp in milliseconds */
    endAt: number | undefined;
    endReasonColor: MantineColor;
}) => (
    <ChatPreviewBadge color={endReasonColor} c="dark.9" leftSection={<Text size="xxs">{endReason}</Text>}>
        {endAt && <CountdownTimer endAt={endAt} />}
    </ChatPreviewBadge>
);

function CountdownTimer({ endAt }: { endAt: number }) {
    const expiryDate = useMemo(() => new Date(endAt), [endAt]);
    const { totalSeconds, restart } = useTimer({ expiryTimestamp: expiryDate });
    const formattedTimeLeft =
        totalSeconds >= 60 ? formatTime(totalSeconds, false) : formatTime(totalSeconds, false, "ss");
    const [timeValue, timeUnit] = formattedTimeLeft.split(" ");

    useEffect(() => {
        restart(expiryDate);
    }, [endAt, expiryDate, restart]);

    return <ElapsedTimeValue value={timeValue} unit={timeUnit} size="xxs" visibleFrom="md" />;
}
